import { type AdvLogicProps, useAdvLogic } from '#shared/lib/adv';
import { getSafeUserRequestContext } from '#shared/lib/context';
import { CALL_ME_BANNER } from '#shared/lib/storage';
import { CALL_ME_BANNER_ALLOWED_SLUGS, CALL_ME_BANNER_END_TIME, CALL_ME_BANNER_START_TIME } from '../constants';

const ADV_LOGIC: Omit<AdvLogicProps, 'id'> = {
    times: 1,
    getTimeout: () => 0,
    startTime: CALL_ME_BANNER_START_TIME,
    endTime: CALL_ME_BANNER_END_TIME,
};

export const useCallMeBanner = () => {
    const { storeSlug } = getSafeUserRequestContext();
    const isAllowedSlug = Boolean(storeSlug && CALL_ME_BANNER_ALLOWED_SLUGS.includes(storeSlug));

    return useAdvLogic({
        ...ADV_LOGIC,
        id: CALL_ME_BANNER,
        times: isAllowedSlug ? ADV_LOGIC.times : 0,
    });
};
